ch-next-data-modeling-render {
  display: contents;
}